import React from 'react';
import UserContainer from '#components/blocks/user/UserContainer';
import ProfileList from '#modules/profileSelection/profilelist/ProfileList';
import useTranslation from 'next-translate/useTranslation';
import { useOvermindActions, useOvermindState } from '#store/overmind';
import { UserProfile } from '#types';
import ResortPassInfo from '#modules/profileSelection/ResortPassInfo';
import {
  ProfileViews,
  useProfileNavigation,
} from '#modules/profileSelection/useProfileNavigationContext';
import CircularProgress from '#components/feedback/circular-progress/CircularProgress';

const ChooseProfileView = () => {
  const { t } = useTranslation();
  const { profile, userProfiles, loading } = useOvermindState().user;
  const { profileSelectionVisible } = useOvermindState().app;
  const { hideProfileSelection } = useOvermindActions().app;
  const { setActiveProfile } = useOvermindActions().user;
  const { setProfileView } = useProfileNavigation();

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const handleSelectProfile = (profile: UserProfile) => {
    hideProfileSelection();
    setActiveProfile(profile);
  };

  const handleCloseButton = () => {
    hideProfileSelection();
  };

  // if this view was opened by the user on purpose the state of profileSelectionVisible will be true
  // and we show a back button
  // If there is no profile selected, don't show a back button.
  const firstButtonProps = {
    ...(profile &&
      profileSelectionVisible && {
        isOutline: true,
        isSecondary: true,
        text: t('backButtonText'),
      }),
  };

  const secondButtonProps = {
    ...(profileSelectionVisible && {
      isOutline: true,
      isSecondary: true,
      text: t('editProfileButton'),
    }),
  };

  return (
    <UserContainer
      title={t('whoIsWatching')}
      onPrimaryClick={() => setProfileView(ProfileViews.EDIT_PROFILE)}
      onSecondaryClick={() => hideProfileSelection()}
      secondButtonProps={secondButtonProps}
      onClose={!!profile ? handleCloseButton : null}
      firstButtonProps={firstButtonProps}
    >
      {loading && (
        <div className="tw-flex tw-items-center tw-justify-center">
          <CircularProgress size={30} color="#fff" />
        </div>
      )}
      {!loading && (
        <>
          <ProfileList
            title={t('chooseProfile')}
            profiles={userProfiles}
            mode={'select'}
            selectedProfileId={profile?.id}
            onSelect={handleSelectProfile}
            onAddButtonClick={() => setProfileView(ProfileViews.CREATE_PROFILE)}
          />
          <ResortPassInfo />
        </>
      )}
    </UserContainer>
  );
};

export default ChooseProfileView;
